<template>
  <div class="statusBody">
    <div
      class="color"
      :style="{
        background: colorList[type],
      }"
    ></div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "green",
    },
  },
  data() {
    return {
      colorList: {
        yello: "#F89F39", // 待执行
        blue: "#5085FF", // 进行中
        green: "#60C873", // 已完成
        red: "#FE7575", // 已失败
        grey: "#8B8B8B", // 已结束
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.statusBody {
  display: flex;
  align-items: center;
  .color {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 4px;
  }
}
</style>
